import type { AxiosInstance } from 'axios';
import type { IProfileApiPort } from '@personnel/application/ports/IProfileApiPort';
import { createProfileHttpClient } from '@personnel/infrastructure/api/ProfileHttpClient';
import { mapApiProfilesListToDomain } from '@personnel/infrastructure/mappers/ProfileApiMapper';

/**
 * Creates the Profiles API repository
 *
 * Orchestrates HTTP client and mappers to expose application-level operations.
 *
 * @param props Configuration with Axios HTTP client
 * @returns Application port implementation for profiles
 *
 * @example
 * const repository = createProfileApiRepository({ httpClient: connectApi });
 * const profiles = await repository.getProfiles();
 */
export const createProfileApiRepository = (props: { httpClient: AxiosInstance }): IProfileApiPort => {
  const profileHttpClient = createProfileHttpClient(props);

  /**
   * Fetches profiles from API and maps them to domain entities
   *
   * @returns Promise with array of Profile entities
   */
  const getProfiles = async () => {
    const response = await profileHttpClient.getProfiles();
    return mapApiProfilesListToDomain(response);
  };

  return {
    getProfiles,
  };
};
